export const API_URL = "https://icswebsite-backend-f0dvfkdbdhgfa5b8.centralindia-01.azurewebsites.net";
// export const API_URL = "http://localhost:4000";